import { AdminAppState } from '../../state';
import { getPlaceId } from './get-place-id';

export const placeHasId = (placeKey: string) => (
  store: AdminAppState,
): boolean => getPlaceId(placeKey)(store).trim().length > 0;
